<template>
  <span :class="['base-badge', `base-badge--${variant}`, `base-badge--${size || 'md'}`]" :style="customStyle">
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  backgroundColor?: string;
  color?: string;
}>();

const customStyle = computed(() => {
  const style: Record<string, string> = {};
  if (props.backgroundColor) style.backgroundColor = props.backgroundColor;
  if (props.color) style.color = props.color;
  return style;
});
</script>

<style scoped>
.base-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.75rem;
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 1;
}

.base-badge--default {
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
}

.base-badge--primary {
  background: var(--color-primary);
  color: var(--color-text-light);
}

.base-badge--success {
  background: #34a853;
  color: var(--color-text-light);
}

.base-badge--warning {
  background: #fbbc04;
  color: var(--color-text-primary);
}

.base-badge--error {
  background: #ea4335;
  color: var(--color-text-light);
}

.base-badge--sm {
  padding: 0.15rem 0.5rem;
  font-size: 0.7rem;
}

.base-badge--md {
  padding: 0.2rem 0.75rem;
  font-size: var(--font-size-xs);
}

.base-badge--lg {
  padding: 0.3rem 1rem;
  font-size: var(--font-size-sm);
}
</style>

